import { useBenefitsStatus } from '@/hooks/use-benefits'
import { enableBenefits } from '@/lib/feature-flags'

/**
 * Severance state for nav gating, derived from the benefits-election status.
 *
 * - `isSeveranceUser`  — the account is part of a severance cohort (has a
 *   severance start date). Regular embrace job-seekers are NOT severance users,
 *   so their nav is unaffected.
 * - `severanceActive`  — severance has begun (start date reached) AND the
 *   election is locked; the outplacement features are switched on.
 * - `severancePending` — a severance user whose severance hasn't started yet;
 *   they should see only the Benefits tab until it does.
 *
 * Only queries when the benefits feature flag is on, so with the flag off this
 * is inert (all false) and the nav behaves exactly as before.
 */
export function useSeveranceStatus() {
  const { data } = useBenefitsStatus(enableBenefits)

  const startDate = data?.severance_start_date ?? null
  const isSeveranceUser = startDate != null
  const severanceActive =
    isSeveranceUser && new Date(startDate as string) <= new Date() && data?.status === 'locked'

  return {
    isSeveranceUser,
    severanceActive,
    severancePending: isSeveranceUser && !severanceActive,
  }
}
